import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'
import { Icon as LegacyIcon } from '@mobi/component-library/Legacy/Icon'
import { hexColors } from '@mobi/settings'
import { promoTypeColorThemes } from '../PromoSelector/constants'
import type { PromoType } from '../PromoSelector/types'

export const PromoBanner: React.FC<{ promoType: PromoType; text: string }> = ({
  promoType,
  text,
}) => {
  const promoTypeClass = `PromoType-${promoType}`
  return (
    <WrapperStyled className={promoTypeClass}>
      {promoType === 'SuperPick' && (
        <span>
          <LegacyIcon type='specials' color={hexColors.lightOrange} size='1.6rem' />
        </span>
      )}

      {promoType === 'KambiReward' && <Icon name='CustomSpecialsGift' size='1.6rem' />}

      <span>{text}</span>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.smx1,
    padding: `${spacing.smx1} ${spacing.sm}`,
    fontFamily: font.family.primary,
    fontSize: font.size.md.fontSize,
    letterSpacing: font.size.md.letterSpacing,
    lineHeight: font.size.md.lineHeight,
    fontWeight: font.weight.medium,
    color: 'var(--dark-color)',
    backgroundColor: 'var(--light-color)',
    borderRadius: radius.md,
    overflow: 'hidden',

    '&.PromoType-KambiReward': {
      border: '1px solid var(--dark-color)',
      borderRadius: radius.lgx1,
      color: colors.neutral[900],
    },

    '> span:first-of-type': {
      flexShrink: 0,
    },

    '> span:last-of-type': {
      flex: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  promoTypeColorThemes
)
